var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.363,
    height: 17.363,
    viewBox: "0 0 17.363 17.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.682,0a8.682,8.682,0,1,0,8.682,8.682A8.677,8.677,0,0,0,8.682,0Zm0,16.152a7.47,7.47,0,1,1,7.47-7.47A7.479,7.479,0,0,1,8.682,16.152Z",
    fill: "#14b7dd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.802 7.237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.939,213.4c-.514,0-.88.217-.88.537v4.354c0,.274.366.549.88.549.491,0,.891-.274.891-.549v-4.354C231.83,213.614,231.43,213.4,230.939,213.4Z",
    transform: "translate(-230.059 -213.397)",
    fill: "#14b7dd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.745 4.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.312,134.208a.823.823,0,1,0,.926.811A.885.885,0,0,0,229.312,134.208Z",
    transform: "translate(-228.375 -134.208)",
    fill: "#14b7dd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFeature);
export default __webpack_public_path__ + "static/media/paymentFeature.2227681477544416d05f16c7f4ce942d.svg";
export { ForwardRef as ReactComponent };